import { ConfigProvider, Grid, Layout } from "antd";
import { brandName } from "@mealmanager/legal-content";
import { type ReactNode } from "react";
import PropTypes from "prop-types";
import { freshGreenTheme, sageCreamPalette } from "./Theme";
import HeaderBar from "./HeaderBar";
import AppFooter from "./AppFooter";
import AppAutoRefresh from "../AppAutoRefresh";

export type AppShellProps = {
    title?: string;
    active?: NavKey;
    onNavigate?: (key: NavKey) => void;
    blogEnabled?: boolean;
    children?: ReactNode;
};

const { Content } = Layout;
const { useBreakpoint } = Grid;

export type NavKey =
    | "home"
    | "recipes"
    | "blog";

const AppShell: React.FC<AppShellProps> = ({
    title = brandName,
    active = "home",
    onNavigate,
    blogEnabled = false,
    children,
}) => {
    const screens = useBreakpoint();
    const isDesktop = !!screens.lg;
    const pageBackground = sageCreamPalette.pageBg;
    return (
        <ConfigProvider
            theme={freshGreenTheme}
        >
            <Layout style={{ height: "100%", minHeight: 0, overflow: "hidden", background: pageBackground }}>
                <AppAutoRefresh />
                <Layout style={{ minHeight: 0, height: "100%", display: "flex", flexDirection: "column", background: pageBackground }}>
                    <HeaderBar isDesktop={isDesktop} onNavigate={onNavigate} blogEnabled={blogEnabled} active={active} />

                    <Content
                        id="app-shell-content"
                        style={{
                            background: pageBackground,
                            flex: 1,
                            padding: 0,
                            minHeight: 0,
                            overflowX: "hidden",
                            overflowY: "auto",
                            overscrollBehavior: "contain",
                            WebkitOverflowScrolling: "touch",
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: '100%',
                                width: "100%",
                            background: pageBackground,
                        }}
                    >
                            <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                                {children}
                            </div>
                            <div style={{ marginTop: 'auto' }}>
                                <AppFooter blogEnabled={blogEnabled} />
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default AppShell;

// --- PropTypes for ESLint react/prop-types rule ---

AppShell.propTypes = {
    title: PropTypes.string,
    active: PropTypes.oneOf([
        "recipes",
        "home",
        "blog",
    ]),
    onNavigate: PropTypes.func,
    blogEnabled: PropTypes.bool,
    actions: PropTypes.node,
    children: PropTypes.node,
};
